module.exports = __webpack_public_path__ + "c7514bc6b01c06896ee3696c0e550221.svg";